<div class="stores">
  <a href="https://apps.apple.com/nl/app/tinqe/id6756956831">
    <img
      width="120"
      height="40"
      src="assets/images/app-store.png"
      alt="Download in de App Store"
    />
  </a>
  <a href="https://play.google.com/store/apps/details?id=nl.enviem.tinqe">
    <img
      width="120"
      height="40"
      src="assets/images/play-store.png"
      alt="Download in Google Play"
    />
  </a>
</div>
